export const IMAGES = {
  ZERO_FEES: {
    src: '/assets/images/apps/auth/zero-fees.svg',
    width: 128,
    height: 64,
  },
  SUPPORT: {
    src: '/assets/images/apps/auth/support.svg',
    width: 128,
    height: 64,
  },
  APP_RATING: {
    src: '/assets/images/apps/auth/app-rating.svg',
    width: 128,
    height: 64,
  },
  VISA: {
    src: '/assets/images/apps/auth/visa.svg',
    width: 114,
    height: 62,
  },
  LOGO_TEXT_BLACK: {
    src: '/assets/images/logo/logo-text-black.svg',
    height: 24,
    width: 127,
  },
  MOBUCKS: {
    src: '/assets/icons/mobucks.svg',
  },
  CREDIT_CARD: {
    src: '/assets/icons/credit_card_green.svg',
  },
  CELEBRATION: {
    src: '/assets/icons/celebration.svg',
  },
  STEPS: {
    src: '/assets/icons/steps.svg',
  },
  SUCCESS: {
    src: '/assets/icons/success-icon.png',
    width: 100,
    height: 100,
  },
  EXCLAMATION: {
    src: '/assets/images/etc/exclamation.webp',
    width: 216,
    height: 216,
  },
  CHECK: {
    src: '/assets/images/pages/modak_brand_newstyle_check.webp',
  },
  DOWNLOAD_QR: {
    src: '/assets/images/etc/download_page_qr_code_desktop.webp',
    width: 168,
    height: 168,
  },
  AVATAR_1: {
    src: '/assets/images/profile/cat1.webp',
  },
  AVATAR_2: {
    src: '/assets/images/profile/panda1.webp',
  },
  AVATAR_3: {
    src: '/assets/images/profile/cat2.webp',
  },
  AVATAR_4: {
    src: '/assets/images/profile/monkey1.webp',
  },
  AVATAR_5: {
    src: '/assets/images/profile/fox1.webp',
  },
  AVATAR_6: {
    src: '/assets/images/profile/dog1.webp',
  },
  AVATAR_7: {
    src: '/assets/images/profile/fox2.webp',
  },
  SPLIT_BILL_CTA: {
    src: '/assets/images/etc/MoSplitBillCta.webp',
    width: 111,
    height: 92,
  },
};
